/*
    This code was automatically generated.
    Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
*/
import { makeBooleanDataField, makeInt64DataField, makeStringDataField } from '../DataFieldHelper';
import { addContractField } from '../Contract';
export var Result;
(function (Result) {
    var contractName = 'Office.System.Result';
    /* Gets data fields for the Office.System.Result contract */
    function getFields(instanceName, contract) {
        var dataFields = [];
        dataFields.push(makeInt64DataField(instanceName + ".Code", contract.code));
        if (contract.type !== undefined) {
            dataFields.push(makeStringDataField(instanceName + ".Type", contract.type));
        }
        if (contract.tag !== undefined) {
            dataFields.push(makeInt64DataField(instanceName + ".Tag", contract.tag));
        }
        if (contract.isExpected !== undefined) {
            dataFields.push(makeBooleanDataField(instanceName + ".IsExpected", contract.isExpected));
        }
        addContractField(dataFields, instanceName, contractName);
        return dataFields;
    }
    Result.getFields = getFields;
})(Result || (Result = {})); // Result
export var Activity;
(function (Activity) {
    Activity.contractName = 'Office.System.Activity';
    /* Gets data fields for the Office.System.Activity contract */
    function getFields(contract) {
        var instanceName = 'Activity';
        var dataFields = [];
        if (contract.cV !== undefined) {
            dataFields.push(makeStringDataField(instanceName + ".CV", contract.cV));
        }
        dataFields.push(makeInt64DataField(instanceName + ".Duration", contract.duration));
        dataFields.push(makeInt64DataField(instanceName + ".Count", contract.count));
        dataFields.push(makeInt64DataField(instanceName + ".AggMode", contract.aggMode));
        if (contract.success !== undefined) {
            dataFields.push(makeBooleanDataField(instanceName + ".Success", contract.success));
        }
        if (contract.result !== undefined) {
            dataFields.push.apply(dataFields, Result.getFields(instanceName + ".Result", contract.result));
        }
        addContractField(dataFields, instanceName, Activity.contractName);
        return dataFields;
    }
    Activity.getFields = getFields;
})(Activity || (Activity = {})); // Activity
export var Host;
(function (Host) {
    var contractName = 'Office.System.Host';
    /* Gets data fields for the Office.System.Host contract */
    function getFields(instanceName, contract) {
        var dataFields = [];
        if (contract.id !== undefined) {
            dataFields.push(makeStringDataField(instanceName + ".Id", contract.id));
        }
        if (contract.version !== undefined) {
            dataFields.push(makeStringDataField(instanceName + ".Version", contract.version));
        }
        if (contract.sessionId !== undefined) {
            dataFields.push(makeStringDataField(instanceName + ".SessionId", contract.sessionId));
        }
        addContractField(dataFields, instanceName, contractName);
        return dataFields;
    }
    Host.getFields = getFields;
})(Host || (Host = {})); // Host
export var User;
(function (User) {
    var contractName = 'Office.System.User';
    /* Gets data fields for the Office.System.User contract */
    function getFields(instanceName, contract) {
        var dataFields = [];
        if (contract.alias !== undefined) {
            dataFields.push(makeStringDataField(instanceName + ".Alias", contract.alias));
        }
        if (contract.primaryIdentityHash !== undefined) {
            dataFields.push(makeStringDataField(instanceName + ".PrimaryIdentityHash", contract.primaryIdentityHash));
        }
        if (contract.primaryIdentitySpace !== undefined) {
            dataFields.push(makeStringDataField(instanceName + ".PrimaryIdentitySpace", contract.primaryIdentitySpace));
        }
        if (contract.tenantId !== undefined) {
            dataFields.push(makeStringDataField(instanceName + ".TenantId", contract.tenantId));
        }
        if (contract.tenantGroup !== undefined) {
            dataFields.push(makeStringDataField(instanceName + ".TenantGroup", contract.tenantGroup));
        }
        if (contract.isAnonymous !== undefined) {
            dataFields.push(makeBooleanDataField(instanceName + ".IsAnonymous", contract.isAnonymous));
        }
        addContractField(dataFields, instanceName, contractName);
        return dataFields;
    }
    User.getFields = getFields;
})(User || (User = {})); // User
export var SDX;
(function (SDX) {
    var contractName = 'Office.System.SDX';
    /* Gets data fields for the Office.System.SDX contract */
    function getFields(instanceName, contract) {
        var dataFields = [];
        if (contract.id !== undefined) {
            dataFields.push(makeStringDataField(instanceName + ".Id", contract.id));
        }
        if (contract.version !== undefined) {
            dataFields.push(makeStringDataField(instanceName + ".Version", contract.version));
        }
        if (contract.instanceId !== undefined) {
            dataFields.push(makeStringDataField(instanceName + ".InstanceId", contract.instanceId));
        }
        if (contract.name !== undefined) {
            dataFields.push(makeStringDataField(instanceName + ".Name", contract.name));
        }
        if (contract.marketplaceType !== undefined) {
            dataFields.push(makeStringDataField(instanceName + ".MarketplaceType", contract.marketplaceType));
        }
        if (contract.sessionId !== undefined) {
            dataFields.push(makeStringDataField(instanceName + ".SessionId", contract.sessionId));
        }
        if (contract.browserToken !== undefined) {
            dataFields.push(makeStringDataField(instanceName + ".BrowserToken", contract.browserToken));
        }
        if (contract.osfRuntimeVersion !== undefined) {
            dataFields.push(makeStringDataField(instanceName + ".OsfRuntimeVersion", contract.osfRuntimeVersion));
        }
        if (contract.officeJsVersion !== undefined) {
            dataFields.push(makeStringDataField(instanceName + ".OfficeJsVersion", contract.officeJsVersion));
        }
        if (contract.hostJsVersion !== undefined) {
            dataFields.push(makeStringDataField(instanceName + ".HostJsVersion", contract.hostJsVersion));
        }
        if (contract.assetId !== undefined) {
            dataFields.push(makeStringDataField(instanceName + ".AssetId", contract.assetId));
        }
        if (contract.providerName !== undefined) {
            dataFields.push(makeStringDataField(instanceName + ".ProviderName", contract.providerName));
        }
        if (contract.type !== undefined) {
            dataFields.push(makeStringDataField(instanceName + ".Type", contract.type));
        }
        addContractField(dataFields, instanceName, contractName);
        return dataFields;
    }
    SDX.getFields = getFields;
})(SDX || (SDX = {})); // SDX
export var Funnel;
(function (Funnel) {
    var contractName = 'Office.System.Funnel';
    /* Gets data fields for the Office.System.Funnel contract */
    function getFields(instanceName, contract) {
        var dataFields = [];
        if (contract.name !== undefined) {
            dataFields.push(makeStringDataField(instanceName + ".Name", contract.name));
        }
        if (contract.state !== undefined) {
            dataFields.push(makeStringDataField(instanceName + ".State", contract.state));
        }
        addContractField(dataFields, instanceName, contractName);
        return dataFields;
    }
    Funnel.getFields = getFields;
})(Funnel || (Funnel = {})); // Funnel
export var UserAction;
(function (UserAction) {
    var contractName = 'Office.System.UserAction';
    /* Gets data fields for the Office.System.UserAction contract */
    function getFields(instanceName, contract) {
        var dataFields = [];
        if (contract.id !== undefined) {
            dataFields.push(makeInt64DataField(instanceName + ".Id", contract.id));
        }
        if (contract.name !== undefined) {
            dataFields.push(makeStringDataField(instanceName + ".Name", contract.name));
        }
        if (contract.commandSurface !== undefined) {
            dataFields.push(makeStringDataField(instanceName + ".CommandSurface", contract.commandSurface));
        }
        if (contract.parentName !== undefined) {
            dataFields.push(makeStringDataField(instanceName + ".ParentName", contract.parentName));
        }
        if (contract.triggerMethod !== undefined) {
            dataFields.push(makeStringDataField(instanceName + ".TriggerMethod", contract.triggerMethod));
        }
        if (contract.timeOffsetMs !== undefined) {
            dataFields.push(makeInt64DataField(instanceName + ".TimeOffsetMs", contract.timeOffsetMs));
        }
        addContractField(dataFields, instanceName, contractName);
        return dataFields;
    }
    UserAction.getFields = getFields;
})(UserAction || (UserAction = {})); // UserAction
//# sourceMappingURL=officeeventschema.tml.js.map